/** Convert text to Title Case — "ACTIVE" → "Active", "ACTIVATION_PENDING" → "Activation Pending" */
export function toTitleCase(text: string): string {
  return text
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

/** Convert text to lowercase — "ACTIVE" → "active" */
export function toLowerText(text: string): string {
  return text.toLowerCase();
}

/** Convert text to UPPERCASE — "active" → "ACTIVE" */
export function toUpperText(text: string): string {
  return text.toUpperCase();
}

/** Convert text to Sentence case — "ACTIVATION_PENDING" → "Activation pending" */
export function toSentenceCase(text: string): string {
  const lower = text.replace(/_/g, ' ').toLowerCase();
  return lower.charAt(0).toUpperCase() + lower.slice(1);
}
